// useSuspended — shared hook that checks whether the logged-in user's org is suspended
// Used to disable action buttons across the portal without duplicating the fetch logic everywhere

import { useState, useEffect } from "react";
import axios from "axios";
import config from "../config";

const API_URL = config.API_URL;

export default function useSuspended() {
  const [isSuspended, setIsSuspended] = useState(false);

  useEffect(() => {
    const storedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
    const orgId = storedUser.organization_id;
    if (!orgId) return;

    axios.get(`${API_URL}/organizations/${orgId}/billing-status`)
      .then(res => setIsSuspended(res.data.status === "suspended"))
      .catch(() => setIsSuspended(false));
  }, []);

  return isSuspended;
}